module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAU5JREFUSA3tlb9OAkEQxlc0IRD1BYi1oZYGWxMfwM6CCp/Bms6W1hobEx8ByEVqa2PPG2gkUHD+Rncvy2Qv90+omGQyOzPffN/OXgjG7C3PC8RxXMdf8CVe1YRDuOqJNkm/Kmtgvi8CNatyZuOUeHpQ0mQWFw6xX04n8FcyZgb3p0uKRjs78+eO/MSdWbfJWYu7dlpcI/Ctm0EBQK/4hQZn5G/0OxqTJvAEMNLgjHwe6gcFWHUYApepBQX4BiPI2gUJ37lYT88U/ZB6PjMPbhC6SSZTCmDnG1zz/scpl8lbvvSB+om6NMX/zfQTPcB8UtGFIzG9wYoP/JV0Sxx44pU/pgUMgBaAK1y2GyM4l4G8dcH6pgVuaN7jDQtaQPzI+RC/y1MH84FvGiQD3Nmag/wjTVzBxqL1gai4DSJJrMlP/lnOEN8SzkvWIzu33fADgqFMSpOoNKUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedback/invoice_w.png
// module id = 0oaY
// module chunks = 2